import React, { memo, ReactNode } from 'react';
import { ClaimShipmentContext, useClaimShipmentProvider } from './context';

const ClaimShipmentProvider = memo(
  ({ children, shipmentId }: { children: ReactNode; shipmentId: string }) => {
    const data = useClaimShipmentProvider(shipmentId);
    return <ClaimShipmentContext.Provider value={data}>{children}</ClaimShipmentContext.Provider>;
  }
);
export default ClaimShipmentProvider;
